<template>
  <div>
    <ul class="py-3">
      <li v-show="isMobile"><a href="#mobileTitle0" data-toggle="collapse" aria-expanded="false" aria-controls="collapseExample">{{ mobileTitle }} <i class="fas fa-chevron-up"></i><i class="fas fa-chevron-down"></i></a></li>
      <ul :class="isMobile ? 'collapse' : ''" id="mobileTitle0">
        <menu-list-content v-on:subMenuToParent="childByValue"></menu-list-content>
      </ul>
    </ul> 
  </div>
</template>

<script>
import MenuListContent from './MenuListContent'

export default {
  name: 'menulist',
  components: {
    MenuListContent
  },
  data(){    
    return {            
      isMobile: window.innerWidth > 767 ? false : true,
      mobileTitle : this.$route.name
    }     
  },
  methods:{
    // 接收子層回傳參數用
    childByValue:function(childValue){      
      this.$emit('subMenuToParent', childValue)      
    },
    screenWidth:function(val){ //監聽螢幕寬度變化
        this.isMobile = val > 767 ? false : true
    }
  },
  //綁定DOM之後
  mounted() {
    var _this = this; //這裡寫的this為vue，若寫在function()內this會變成method本身
    window.onresize = function(){ // 定義視窗大小變化事件                   
        _this.screenWidth(window.innerWidth); //視窗寬度           
    }    
  }
}
</script>


// WEBPACK FOOTER //
// src/components/MenuList.vue